require('./scss/styles.scss')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as directives from './directives'
import * as filters from './filters'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'

Vue.use(VueTabs)

import VueCircleSlider from 'vue-circle-slider'

Vue.use(VueCircleSlider)

import VueCharts from 'vue-charts'

Vue.use(VueCharts)

//vue-awesome
Vue.component('icon', Icon)

Vue.component('multiselect', Multiselect)

Vue.use(VueAwesomeSwiper)

// import 'swiper/dist/css/swiper.css'


// vue2-google-maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCx8ghi_qXr6KToLFS0R18UIYI25KKo1lI',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)
    }
})

const numeral = require('numeral')

numeral.register('locale', 'es-es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'mm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        let b = number % 10
        return (b === 1 || b === 3) ? 'er' : (b === 2) ? 'do' : (b === 7 || b === 0) ? 'mo' : (b === 8) ? 'vo' : (b === 9) ? 'no' : 'to'
    },
    currency: {
        symbol: '€'
    }
})

numeral.locale('es-es')

Vue.filter('formatNumber', function (value) {
    if ( !value  || value === 0) {
        return '-'
    } else {
        return numeral(value).format('0,0.00')
    }
})

Vue.filter('formatDateAsLocal', function (value) {
    if ( !value  || value === 0) {
        return '-'
    } else {
        //console.log('formatDateAsLocal value: ')
        //console.log(value)
        return moment(value, 'X').format('LLLL')
    }
})




Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]) })

const app = new Vue({
    el: '#app',
    template: '<App/>',
    router,
    store,
    components: {App}
})


// Others
// Disable mousewheel on input type number
/*
document.addEventListener("mousewheel", function(event){
    if(document.activeElement.type === "number"){
        document.activeElement.blur()
    }
})
*/


// WEBPACK FOOTER //
// ./src/app.js